import React, { Component } from 'react';
import './questions-list.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import ReactTooltip from 'react-tooltip';

class QuestionList extends Component {

    state = {
        isCompetecyQuestionsPresent: false,
        showEditQuestionTime: false
    }

    contentsHash = {}

    constructor(props) {
        super(props)

        // console.log(this.props.approximateTime, this.props.contents)

        this.state = {
            contents: this.props.contents,
            reload: true,
            questionCount: this.props.questionCount,
            approximateTime: this.props.approximateTime,
            enableSelectionButton: false,
            showCompetencyOnly: this.props.showCompetencyOnly
        }

        if (Object.keys(this.props.contentsHash).length) {
            this.contentsHash = this.props.contentsHash
        } else {
            this.props.contents.forEach(item => {
                this.contentsHash[item.id] = { contentId: item.id, selected: true, duration: item.duration }
            });
        }
    }

    componentDidMount() {
        let isCompetecyQuestionsPresent = this.state.isCompetecyQuestionsPresent

        if (this.props.contents.length && !this.props.isCreate) {
            for (let i = 0; i < this.props.contents.length; i++) {
                let question = this.props.contents[i]

                if ((question.questionCategory === 'C1' ||
                    question.content.competency && question.content.competency.id === 'YES' ||
                    question.skill === 'Comprehension')) {
                    isCompetecyQuestionsPresent = true
                    break;
                }
            }
        }

        this.setState({ isCompetecyQuestionsPresent })
    }

    setSelectedQuestions = () => {

        // console.log('set selected')

        let approximateTime = 0
        for (let key in this.contentsHash) {
            let content = this.contentsHash[key]

            if (content.selected) {
                approximateTime += content.duration
            }
        }

        if (this.state.showEditQuestionTime) {
            this.setState({ showEditQuestionTime: false })
        }


        if (this.props.questionCount != this.state.questionCount || this.props.approximateTime != approximateTime) {
            let obj = {
                selectedContentAssessment: true,
                contentsHash: this.contentsHash,
                approximateTime: approximateTime,
                questionCount: this.state.questionCount
            }
            this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions(obj)
        }


        if (this.state.showCompetencyOnly) {
            this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions()
        }
    }


    onSelectQuestion = (contentId, value, key) => {
        console.log(this.props.questionCount)

        if (this.contentsHash[contentId]) {

            this.contentsHash[contentId].selected = value

            let mins = 0

            if (value) {
                // if (key === 'Knowledge') {
                //     mins = 1  // 1 min for one Question
                // } else if (key === 'Calculation') {
                //     mins = 2 // 1.5 min for Each question
                // } else if (key === 'Modelling') {
                //     mins = 3 // 2.5 min for Each Question
                // } else if (key === 'Comprehension') {
                //     mins = 4 // 3.5 min for Each Question
                // }
                mins = this.contentsHash[contentId].duration

                this.setState({ questionCount: this.state.questionCount + 1, approximateTime: this.state.approximateTime + mins }, () => {
                    if (this.props.questionCount === this.state.questionCount) {
                        this.setState({ enableSelectionButton: false })
                    }
                })
            } else {
                // if (key === 'Knowledge') {
                //     mins = 1  // 1 min for one Question
                // } else if (key === 'Calculation') {
                //     mins = 2 // 1.5 min for Each question
                // } else if (key === 'Modelling') {
                //     mins = 3 // 2.5 min for Each Question
                // } else if (key === 'Comprehension') {
                //     mins = 4 // 3.5 min for Each Question
                // }
                mins = this.contentsHash[contentId].duration
                this.setState({ questionCount: this.state.questionCount - 1, approximateTime: this.state.approximateTime - mins }, () => {
                    if (this.props.questionCount != this.state.questionCount - 1) {
                        this.setState({ enableSelectionButton: true })
                    }
                })
            }



            this.setState({ reload: false }, () => {
                this.setState({ reload: true })
            })
        }
    }




    onClickBack = () => {
        this.props.back()
    }

    handleChange = (event, questionId) => {
        const value = +event.target.value;
        console.log(value, questionId)

        let contentsList = this.state.contents
        let index = contentsList.findIndex(item => item.id === questionId)

        if (contentsList[index]) {
            this.contentsHash[questionId].duration = value
            contentsList[index].content.duration = value
            let approximateTime = 0
            for (let key in this.contentsHash) {
                let content = this.contentsHash[key]

                if (content.selected) {
                    approximateTime += content.duration
                }
            }

            this.setState({ contents: contentsList, approximateTime })
        }


        // Prevent values above 50
        // if (value <= 50) {
        //     this.setState({ questionCount: value }, () => {
        //     });
        // }
    };

    handleChangeForAllQuestionTime = (event) => {
        let allQuestionTime = +event.target.value
        if(!allQuestionTime) {
            return;
        }
        this.setState({ allQuestionTime })
        let contentsList = this.state.contents

        contentsList.forEach(item => {
            this.contentsHash[item.id].duration = allQuestionTime
            item.content.duration = allQuestionTime
        })

        let approximateTime = 0
        for (let key in this.contentsHash) {
            let content = this.contentsHash[key]
            if (content.selected) {
                approximateTime += content.duration
            }
        }

        console.log(this.contentsHash)

        this.setState({ contents: contentsList, approximateTime })

    }


    renderList = () => {

        let continousIndex = 1

        return (
            this.state.contents?.map((question, index) => (
                <div className="concept-wrapper" onMouseEnter={ReactTooltip.rebuild}>
                    <div className='row pt-4 flex-no-wrap ' >
                        {
                            !this.props.questionSelection ?
                                <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number'
                                >
                                    <div className='ml-2'>{`Q${continousIndex++}`}</div>
                                </div>
                                :
                                <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number cursor-pointer'
                                    onClick={() => this.onSelectQuestion(question.id, !this.contentsHash[question.id].selected, question.skill)}>
                                    <div>
                                        {
                                            this.state.reload && this.contentsHash[question.id] && this.contentsHash[question.id].selected ? <div className="">
                                                <img className="green-tick-icon" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                            </div>
                                                :
                                                <div className="check-box"></div>
                                        }
                                    </div>
                                    <div className='ml-4'>{`Q${continousIndex++}`}</div>
                                </div>
                        }

                        <div className='col'>
                            <div className='qn-title'><CwContentViewer content={question.content.title} /></div>
                            {question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                            )
                                :
                                ""}
                        </div>
                        <div className='col-1 d-flex align-items-center'>
                            {
                                (question.questionCategory === 'C1' ||
                                    question.content.competency && question.content.competency.id === 'YES' ||
                                    question.skill === 'Comprehension') ?
                                    <img className='info-icon-size mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                    :
                                    <img className='info-icon-size no-image-margin-right'></img>
                            }
                            {
                                (!question.content.type || question.content.isMultiStep) ?
                                    <img className='info-icon-size mr-2' src={getImageSource(ImageConstants.MULTI_STEP_IMAGE)} />
                                    :
                                    <img className='info-icon-size no-image-margin-right'></img>
                            }
                        </div>
                        <div className='col-1 d-flex align-items-center cursor-pointer'>
                            <img className='info-icon-size'
                                data-tip={`${question.content.chapterTitle ? question.content.chapterTitle : ''}`}
                                src={getImageSource(ImageConstants.INFO1)} />
                        </div>
                        {
                            this.state.showEditQuestionTime ?
                                <div className={`col-1 qn-title d-flex align-items-center`}>
                                    <input className='input-style'
                                        style={{ borderRadius: '10px' }}
                                        type="number"
                                        min="0"
                                        max="50"
                                        placeholder="Enter Question Count"
                                        onChange={(e) => this.handleChange(e, question.id)}
                                        value={question.content.duration ? question.content.duration : ''} />
                                </div>
                                :
                                <div className='col-1 qn-title d-flex align-items-center'>{question.content.duration ? question.content.duration : ''}mins</div>
                        }
                    </div>
                </div>
            ))
        )
    }

    showCompetency() {
        this.props.delegate && this.props.delegate.showCompetencyQuestionsOnly && this.props.delegate.showCompetencyQuestionsOnly(!this.state.showCompetencyOnly)
        this.setState({ showCompetencyOnly: !this.state.showCompetencyOnly })
    }

    onClickEditQuestionTime() {
        if (this.state.showEditQuestionTime) {
            this.setState({ showEditQuestionTime: false })
            let approximateTime = 0
            for (let key in this.contentsHash) {
                let content = this.contentsHash[key]

                if (content.selected) {
                    approximateTime += content.duration
                }
            }

            this.setState({ approximateTime }, () => {
                this.setSelectedQuestions()
            })

        } else {
            this.setState({ showEditQuestionTime: true })
        }

    }

    render() {
        return (
            <div className='question-detail-new-v3'>

                {/* <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div> */}

                {/* <div className="pt-4 my-auto text-right"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.onClickBack.bind(this)} /></div> */}
                <div className='mt-4 qs-font-weight'>Questions</div>
                <div className='mt-3 apx-time-size'>
                    <span className="question-wrapper-count-wrapper">
                        <span>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.QUESTION_MARK)} /> <b className="pl-1"> {this.props.questionCount || 0}</b>
                        </span>
                    </span>
                    <span className="p-2 ml-3 time-count-wrapper">
                        <span>
                            <img className='question-mark-icon' src={getImageSource(ImageConstants.CLOCK_IMAGE)} /> <b className="pl-1">{this.props.approximateTime || 0} </b>
                            mins
                        </span>
                    </span>

                    <button className='time-change-wrapper cursor-pointer ml-3' style={{ border: 'none' }} onClick={() => this.onClickEditQuestionTime()}>
                        {this.state.showEditQuestionTime ? 'Save Question Time' : 'Edit Question Time'}</button>

                    <span className='float-right time-count-wrapper mr-4' style={{ fontWeight: 'bold' }}>{this.state.approximateTime}mins</span>
                </div>
                {/* {
                    this.state.isCompetecyQuestionsPresent ?
                        <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >
                            {
                                this.state.showCompetencyOnly ?
                                    <div>
                                        <img className="green-tick-icon-for-competency" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                    </div>
                                    :
                                    <div>
                                        <div className="empty-check-box"></div>
                                    </div>
                            }
                            <div className='d-flex align-items-center ml-2'>
                                <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                <span className='competency-text'>Show Competency Questions only</span>
                            </div>
                        </div>

                        :
                        <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >

                            <div className='d-flex align-items-center ml-2'>
                                <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                <span className='competency-text'>No Competency Questions</span>
                            </div>
                        </div>

                } */}
                <div className='qs-border mt-4 mb-2'></div>
                {
                    this.state.showEditQuestionTime ?
                        <div className='d-flex justify-content-end align-items-center mr-3'>
                            <div className='change-all-question-time-text'>Change All Question Time As</div>
                            <div className={`ml-3 qn-title d-flex align-items-center`}>
                                <input className='input-style'
                                    style={{ borderRadius: '10px' }}
                                    type="number"
                                    min="1"
                                    max="50"
                                    placeholder="QT"
                                    onChange={(e) => this.handleChangeForAllQuestionTime(e)}
                                    value={this.state.allQuestionTime} />
                            </div>
                            <div className='apply-button cursor-pointer' onClick={() => this.onClickEditQuestionTime()}>Apply</div>
                        </div>
                        :
                        <></>
                }

                <div>
                    {!this.props.isCreate ? this.renderList() : ''}
                </div>
                {
                    !this.props.questionSelection ?
                        <></>
                        :
                        <div className="modal-footer">
                            <button className="apply-btn" onClick={this.setSelectedQuestions.bind(this)} >Apply Selected</button>
                            <button className="cancel-btn" onClick={this.onClickBack.bind(this)} >Cancel</button>
                        </div>
                }
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        );
    }
}

export default QuestionList;